/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { LitElement, html } from 'lit';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import styles from './masthead.scss';

const { stablePrefix: c4dPrefix } = settings;

/**
 * MegaMenu Category Group Description.
 *
 * @element c4d-megamenu-category-group-desc
 */
@customElement(`${c4dPrefix}-megamenu-category-group-copy`)
class C4DMegaMenuCategoryGroupCopy extends LitElement {
  render() {
    return html` <slot></slot> `;
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

export default C4DMegaMenuCategoryGroupCopy;
